import { Select } from "@king-ict/eupisi-ui/components";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useTranslation } from "react-i18next";

import { useAuth } from "../hooks";

export const UserLoginBox = () => {
    const { t } = useTranslation();

    const auth = useAuth();
    if (auth.isLoading) return null;

    const handleRoleChangeNumber = async (roleId: number) => {
        await auth.roleChange(roleId);
        window.location.reload();
    };

    const handleLogOut = async () =>{
        await auth.logout();
    }

    const UserName = () => {
        if (!auth.user) return null;
        return (
            <>
                <span> {auth.user.firstName} </span>
                <span> {auth.user.lastName}  - </span>
                <span> {auth.user.oib} - </span>
                <b> {auth.currentRole?.name}</b>
                {/* TODO - remove this - just for demonstation */}
                {/* {auth.hasPremission(1) && (console.log(1))} */}
            </>
        );
    }

    return (
            <Nav className="me-auto">
                <NavDropdown
                    title={UserName()}
                    id="basic-nav-dropdown"
                >
                    <NavDropdown.Header>{t("login.userRoles")}</NavDropdown.Header>
                    <NavDropdown.ItemText>
                    <Select
                            name={auth.currentRole?.name}
                            value={auth.currentRole?.id}
                            onChange={(e) => handleRoleChangeNumber(e.target.value)}
                            selectData={codeBookToSelectData(auth.roles)}
                            readonly={(auth.roles.length ?? 1) === 1}
                            />
                    </NavDropdown.ItemText>
                    <NavDropdown.Divider />
                    { (auth.currentRole?.canImpersonate) &&
                        <>
                            <NavDropdown.Item href="#">{t("login.impersonate")}</NavDropdown.Item>
                            <NavDropdown.Divider />
                        </>
                    }
                    <NavDropdown.Item onClick={(e) =>handleLogOut()}>{t("login.logoutButton")}</NavDropdown.Item>
               </NavDropdown>
            </Nav>
    );
}
